import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  DeleteHomeScreenBanner,
  DeleteHomeScreenBannerVariables
} from './__generated__/DeleteHomeScreenBanner'

const MUTATION = gql`
  mutation DeleteHomeScreenBanner($id: String!) {
    deleteHomeScreenBanner: deleteHomeScreenBannerV2(id: $id) {
      ... on HomeScreenBannerV2 {
        id
        title
      }
      ... on HomeScreenBannerErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteHomeScreenBanner = () =>
  useMutation<DeleteHomeScreenBanner, DeleteHomeScreenBannerVariables>(MUTATION)
